/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.PlaylistChirpService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const createPlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'createPlaylist',
  auth: 'app',
  fingerprint: '5Wk5n8N68Pus44gtw_5wW4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updatePlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'updatePlaylist',
  auth: 'app',
  fingerprint: 'qAm32Mj-Iuys44gtw_5wW4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistByIdRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'getPlaylistById',
  auth: 'app',
  fingerprint: '-CWYlUvyTZWs44gtw_5wW4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const addPlaylistItemRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'addPlaylistItem',
  auth: 'app',
  fingerprint: 'GlsQPycDsfOs44gtw_5wW4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePlaylistItemRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'deletePlaylistItem',
  auth: 'app',
  fingerprint: 'Q8Y7041XiKWs44gtw_5wW4mPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const savePlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'savePlaylist',
  auth: 'app',
  fingerprint: 'L7cV7et0ugSOUe2e_r4XmYmPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const unsavePlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'unsavePlaylist',
  auth: 'app',
  fingerprint: 'L7cV7et0ugSOUe2e_r4XmYmPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.PlaylistChirpService',
  rpcName: 'search',
  auth: 'app',
  fingerprint: 'WLBPHfLVs1msB3j2E9DT4ImPIruyndla',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};